<template>
  <v-menu
    ref="menu"
    v-model="showMenu"
    :close-on-content-click="false"
    offset-y
    max-width="290px"
    min-width="290px"
  >
    <!-- bind attrs into the text field to pass accessibility attributes -->
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="dateFormatted"
        outlined
        prepend-inner-icon="mdi-calendar"
        placeholder="dd/mm/yyyy"
        :label="label"
        readonly
        v-bind="{...$attrs, ...attrs}"
        v-on="on"
      />
    </template>
    <v-date-picker
      v-model="localDateValue"
      v-bind="datePickerProps"
      no-title
      @input="saveValue"
    />
  </v-menu>
</template>

<script>
export default {
  name: 'DatePicker',
  data() {
    return {
      showMenu: false,
      dateFormatted: null,
      localDateValue: null
    }
  },
  props: {
    value: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: 'Date'
    },
    datePickerProps: {
      type: Object,
      default: null
    }
  },
  created() {
    if (this.value) {
      const d = new Date(this.value);
      // re-format iso date/time to local date
      // e.g. UTC ISO date string, "2020-01-01T23:00:00Z" will be 2020-01-02 in AEST
      this.localDateValue = `${d.getFullYear()}-${(d.getMonth() + 1).toString().padStart(2, '0')}-${d.getDate().toString().padStart(2, '0')}`;
      this.dateFormatted = this.formatDate(this.localDateValue);
    }
  },
  watch: {
    localDateValue(val) {
      // returns as iso yyyy-mm-dd format
      this.dateFormatted = this.formatDate(this.localDateValue);
      // emit the change for pseudo two way binding
      this.$emit('input', val);
    },
  },
  methods: {
    formatDate (date) {
      if (!date) return null

      const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

      const [year, month, day] = date.split('-')
      return `${day} ${months[month-1]} ${year}`
    },
    saveValue() {
      this.showMenu = false;
    }
  }
}
</script>

<style scoped lang="scss">

</style>
